import { normalizeModulesResponse } from "../modules/moduleUtils";

const MODULES_BOOTSTRAPPED_EVENT = "bhp:modules-bootstrapped";

let bootstrappedModulesCache = null;

export const setBootstrappedModules = (payload) => {
  bootstrappedModulesCache = normalizeModulesResponse(payload);

  if (typeof window !== "undefined") {
    window.dispatchEvent(
      new CustomEvent(MODULES_BOOTSTRAPPED_EVENT, {
        detail: bootstrappedModulesCache,
      }),
    );
  }

  return bootstrappedModulesCache;
};

export const getBootstrappedModules = () => {
  return Array.isArray(bootstrappedModulesCache) ? bootstrappedModulesCache : null;
};

export const clearBootstrappedModules = () => {
  bootstrappedModulesCache = null;
};

export const getModulesBootstrappedEventName = () => MODULES_BOOTSTRAPPED_EVENT;
